// Fixed cost article numbers
export const FIXED_COST_ARTICLES = ['94', '95', '96', '97'];

// Hourly pricing article number
export const HOURLY_ARTICLE = '92';

// Default work time for different scenarios
export const DEFAULT_HOURLY_WORK_TIME = '8:00';
export const DEFAULT_FIXED_UNITS = '1';

// Error display timeout
export const ERROR_TOOLTIP_TIMEOUT = 3000;

// Validation error keys
export const VALIDATION_ERRORS = {
  VALIDATE_ARTICLE: 'validateArticle',
  VALIDATE_AMOUNT: 'validateAmount',
  VALIDATE_TIME: 'validateTime',
  NO_DATE_SELECTED: 'noDateSelected',
  VALIDATE_FILE_SIZE: 'validateFileSize',
  INVALID_ARTICLE_FOR_PRICING: 'invalidArticleForPricing'
} as const;

// Dropdown option factory functions
export const createAccommodationOptions = (t: (key: string) => string) => [
  { value: '', label: t('SELECT_ACCOMMODATION_TYPE') },
  { value: 'hotel', label: t('HOTEL') },
  { value: 'apartment', label: t('APARTMENT') },
  { value: 'house', label: t('HOUSE') },
  { value: 'other', label: t('OTHER') }
];

export const createAllowanceOptions = (t: (key: string) => string) => [
  { value: '', label: t('SELECT_ALLOWANCE') },
  { value: 'half_day', label: t('HALF_DAY') },
  { value: 'full_day', label: t('FULL_DAY') },
  { value: 'custom', label: t('CUSTOM_AMOUNT') }
];

export const createShowDatesOptions = (t: (key: string) => string) => [
  { value: 'yes', label: t('YES') },
  { value: 'no', label: t('NO') }
];

export const createHoursPerDayOptions = (t: (key: string) => string) => [
  { value: 'service_invoice', label: t('SERVICE_INVOICE') },
  { value: 'worksheet_pay', label: t('WORKSHEET_PAY') }
];

export const createServiceOptions = (articles: any[]) =>
  articles.map(article => ({
    value: article.articleNumber,
    label: article.articleName,
    id: article.id
  }));
